export const darkTheme = {
	background: '#171717',
	text: '#fff',
	green: '#08D466',
	font: '' / 'Lato' / ', sans-serif',
};

export const lightTheme = {
	background: '#fff',
	text: '#171717',
	green: '#08D466',
	font: '' / 'Lato' / ', sans-serif',
};
